import React, { useMemo, useContext } from 'react';
import { AuthContext } from 'contexts';
import { Link } from 'react-router-dom';
import { paramaterize } from 'utils';
import { useListings } from '../hooks';
import { ListingLayoutCard, Loading } from '../components';
import ListingsSection from '../Section/ListingsSection';

const ListingsCard: React.FC = () => {
  const { auth, orgPlan } = useContext(AuthContext);

  const {
    availabilityOptions,
    availability,
    filteredListingsByAvailability: listings,
    onStatusChange,
    onAvailabilityChange,
    isLoading,
    searchValue,
    setSearchValue,
  } = useListings({ searchType: 'user' });

  const redirectUrl = useMemo(() => {
    let url = `/listing/list/brokerage/0?agent=${auth?.id}`;
    if (orgPlan?.name === 'AGENT') {
      url = `/listing/list/user/0?${paramaterize({
        searchType: 'user',
        status: 'All',
        location: 'All',
        locationAddress: 'All',
        avail: 'All',
        type: 'user',
      })}`;
    }
    return url;
  }, [auth?.id, orgPlan?.name]);

  const actions = useMemo(() => listings.length > 0
      ? {
          actions: [
            <Link key="view-all-link" to={redirectUrl}>
              View All
            </Link>,
          ],
        }
      : {}, [listings, redirectUrl]);

  return (
    <ListingLayoutCard
      search={{
        searchValue,
        onSearchValueChange: setSearchValue,
      }}
      titleLink={{
        title: <span data-cy="view-all-listings">Listings</span>,
        linkPath: `/listing/list/user/0?${paramaterize({
          searchType: 'user',
          status: 'All',
          location: 'All',
          locationAddress: 'All',
          avail: 'All',
          type: 'user',
        })}`,
      }}
      onStatusChange={onStatusChange}
      onAvailabilityChange={onAvailabilityChange}
      availabilityOptions={availabilityOptions}
      availability={availability}
      data-cy="dashboard-listings-card"
      {...actions}
    >
      {isLoading ? <Loading /> : <ListingsSection listings={listings} />}
    </ListingLayoutCard>
  );
};

export default ListingsCard;
